import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { message, notification } from 'antd';
import * as userActions from '../../core/user/userActions';
import DOM from './resetPasswordForm';
import { triggerErrorNotification } from '../../core/utils/notificationUtils';

class UserResetPasswordForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisiblePasswordResetModal: false,
            isSucessResetPassword: false,
            isValidResetPassword: false,
        };
        this.view = DOM;
    }

    componentWillUnmount() {
        this.setState({
            isSucessResetPassword: false,
            isValidResetPassword: false,
        });
    }

    componentDidMount() {
        this.setState({
            isValidResetPassword: this.props.isValidResetPassword,
        });
    }

    setIsVisiblePasswordResetModal(isVisiblePasswordResetModal) {
        this.setState({ isVisiblePasswordResetModal });
    }

    handleSubmit = (e) => {
        const { token, user } = this.props;
        
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (values.new_password !== values.new_password_confirm) {
                triggerErrorNotification('The entered password does not match!');
                return;
            }
            if (!err) {
                const { actions, form } = this.props;
                let error = false;

                if (values.new_password !== values.new_password_confirm) {
                    error = true;
                    message.error('New password does not match!');
                }

                if (!error) {
                    actions.changeResetPasswordRequest({ ...values, token });
                    this.setState({
                        isSucessResetPassword: user.isSucessResetPassword,
                    });
                    form.resetFields();
                }
            }
        });
    };

    sendPasswordResetEmail = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll(['email'], (err, values) => {
            if (!err) {
                const { actions } = this.props;
                actions.resetPasswordRequest({ email: values.email });
                this.setState({ isVisiblePasswordResetModal: false });
            }
        });
    };

    render() {
        return this.view();
    }
}

UserResetPasswordForm.propTypes = {
    form: PropTypes.object.isRequired,
};

const ResetPasswordForm = Form.create()(UserResetPasswordForm);

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        isSucessResetPassword: state.user.isSucessResetPassword,
        isValidResetPassword: state.user.isValidResetPassword,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...userActions,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ResetPasswordForm);
